import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { CatalogoTiposNovedadQuery } from './tipos-novedad.service';

export interface SubtipoDTO {
  idSubtipoNovedad: number;
  tipoNovedadId: number;
  subtipoNovedad: string;
  estado: number | string;
  /** Desde BD: «Si» / «No» — auto-selección de todos los integrantes cuando aplica. */
  aplicaNovedadIntegrantes?: string | null;
  codigoSubtipo: string;
}

export interface SubtiposNovedadDTO {
  idTipoNovedad: number;
  tipoNovedad: string;
  aplicaContratoTransitorio: number | boolean;
  estado: number | string;
  subtipos: SubtipoDTO[];
}

@Injectable({
  providedIn: 'root',
})
export class SubtiposNovedadService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.SUBTIPOS_NOVEDAD}`;
  private tiposNovedadBaseUrl = `${ENV.HOST}${URL_MAP.API.TIPOS_NOVEDAD}`;

  constructor(private http: HttpClient) {}

  private buildCatalogoParams(query: CatalogoTiposNovedadQuery): HttpParams {
    let p = new HttpParams().set(
      'contratoTransitorio',
      query.contratoTransitorio ? 'true' : 'false',
    );
    const id = query.idTipoSolicitud;
    if (id != null && Number.isFinite(Number(id))) {
      p = p.set('idTipoSolicitud', String(id));
    }
    return p;
  }

  getSubtiposNovedad(
    query: CatalogoTiposNovedadQuery,
  ): Observable<SubtiposNovedadDTO[]> {
    return this.http.get<SubtiposNovedadDTO[]>(this.apiUrl, {
      params: this.buildCatalogoParams(query),
    });
  }

  /**
   * GET /tipos-novedad/{tipoNovedadId}/subtipos (ova-back-traslados).
   */
  getSubtiposPorTipoNovedad(
    tipoNovedadId: string | number,
    query?: CatalogoTiposNovedadQuery,
  ): Observable<SubtipoDTO[]> {
    const id = encodeURIComponent(String(tipoNovedadId));
    const params = query ? this.buildCatalogoParams(query) : undefined;
    return this.http.get<SubtipoDTO[]>(
      `${this.tiposNovedadBaseUrl}/${id}/subtipos`,
      params ? { params } : {},
    );
  }
}
